(function () {
  var AUTOPLAY_MS = 3000;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function MelbourneMarathon2026Product(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mm2026-tab]'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-mm2026-panel]'));
    this.interval = parseInt(root.getAttribute('data-autoplay-ms') || String(AUTOPLAY_MS), 10);
    if (!Number.isFinite(this.interval) || this.interval < 0) {
      this.interval = AUTOPLAY_MS;
    }
    this.index = 0;
    this.timer = null;
    this.onTabClick = this.handleTabClick.bind(this);
    this.onEnter = this.stop.bind(this);
    this.onLeave = this.start.bind(this);

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        this.onTabClick(index);
      }.bind(this));
    }, this);

    this.root.addEventListener('mouseenter', this.onEnter);
    this.root.addEventListener('mouseleave', this.onLeave);
    this.root.addEventListener('focusin', this.onEnter);
    this.root.addEventListener('focusout', this.onLeave);

    this.show(0);
    this.start();
  }

  MelbourneMarathon2026Product.prototype.show = function (index, options) {
    if (!this.tabs.length) return;

    var next = index % this.tabs.length;
    if (next < 0) next = this.tabs.length - 1;
    this.index = next;

    this.tabs.forEach(function (tab, i) {
      var active = i === next;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });

    this.panels.forEach(function (panel, i) {
      var active = i === next;
      panel.classList.toggle('is-active', active);
      panel.classList.toggle('active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', 'hidden');
      }
    });

    this.root.dispatchEvent(new CustomEvent('mm2026:product-tab-change', {
      bubbles: true,
      detail: {
        userInitiated: !!(options && options.userInitiated)
      }
    }));
  };

  MelbourneMarathon2026Product.prototype.next = function () {
    this.show(this.index + 1);
  };

  MelbourneMarathon2026Product.prototype.start = function () {
    this.stop();
    if (this.interval <= 0 || this.tabs.length < 2 || prefersReducedMotion()) return;
    this.timer = window.setInterval(function () {
      this.next();
    }.bind(this), this.interval);
  };

  MelbourneMarathon2026Product.prototype.stop = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  MelbourneMarathon2026Product.prototype.handleTabClick = function (index) {
    this.show(index, { userInitiated: true });
    this.start();
  };

  MelbourneMarathon2026Product.prototype.destroy = function () {
    this.stop();
    this.root.removeEventListener('mouseenter', this.onEnter);
    this.root.removeEventListener('mouseleave', this.onLeave);
    this.root.removeEventListener('focusin', this.onEnter);
    this.root.removeEventListener('focusout', this.onLeave);
  };

  function boot(root) {
    if (!root || root._mm2026Product) return;
    root._mm2026Product = new MelbourneMarathon2026Product(root);
  }

  function bootAll() {
    document.querySelectorAll('.mm2026-product').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.mm2026-product');
    if (root) boot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('.mm2026-product');
    if (root && root._mm2026Product) {
      root._mm2026Product.destroy();
      root._mm2026Product = null;
    }
  });

  document.addEventListener('shopify:section:select', bootAll);
})();
